
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/grammatical-range-and-accuracy",
      function () {
        return require("private-next-pages/elearning/grammatical-range-and-accuracy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/grammatical-range-and-accuracy"])
      });
    }
  